import { render, staticRenderFns } from "./substituteMining.vue?vue&type=template&id=5541fd6b&"
import script from "./substituteMining.vue?vue&type=script&lang=js&"
export * from "./substituteMining.vue?vue&type=script&lang=js&"
import style0 from "./substituteMining.vue?vue&type=style&index=0&id=5541fd6b&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5541fd6b')) {
      api.createRecord('5541fd6b', component.options)
    } else {
      api.reload('5541fd6b', component.options)
    }
    module.hot.accept("./substituteMining.vue?vue&type=template&id=5541fd6b&", function () {
      api.rerender('5541fd6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/substituteMining.vue"
export default component.exports